export default "__VITE_ASSET__BXsXvlXn__"